"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuleScopeSelector = exports.findRule = exports.createSubsetAst = exports.createWarningRule = exports.isInConditionalGroup = exports.isChildOfAtRule = void 0;
const selector_1 = require("./selector");
const css_selector_parser_1 = require("@tokey/css-selector-parser");
const postcss = __importStar(require("postcss"));
const deprecation_1 = require("./deprecation");
function isChildOfAtRule(rule, atRuleName) {
    return !!(rule.parent &&
        rule.parent.type === 'atrule' &&
        rule.parent.name === atRuleName);
}
exports.isChildOfAtRule = isChildOfAtRule;
function isInConditionalGroup(node, includeRoot = true) {
    // https://www.w3.org/TR/css-conditional-3/#contents-of
    const parent = node.parent;
    return (parent &&
        ((includeRoot && parent.type === `root`) ||
            (parent.type === `atrule` && (parent.name === `media` || parent.name === `supports`))));
}
exports.isInConditionalGroup = isInConditionalGroup;
function createWarningRule(extendedNode, scopedExtendedNode, extendedFile, extendingNode, scopedExtendingNode, extendingFile, useScoped = false) {
    const message = `"class extending component '.${extendingNode} => ${scopedExtendingNode}' in stylesheet '${extendingFile}' was set on a node that does not extend '.${extendedNode} => ${scopedExtendedNode}' from stylesheet '${extendedFile}'" !important`;
    return postcss.rule({
        selector: `.${useScoped ? scopedExtendingNode : extendingNode}:not(.${useScoped ? scopedExtendedNode : extendedNode})::before`,
        nodes: [
            postcss.decl({
                prop: 'content',
                value: message,
            }),
            postcss.decl({
                prop: 'display',
                value: `block !important`,
            }),
            postcss.decl({
                prop: 'font-family',
                value: `monospace !important`,
            }),
            postcss.decl({
                prop: 'background-color',
                value: `red !important`,
            }),
            postcss.decl({
                prop: 'color',
                value: `white !important`,
            }),
        ],
    });
}
exports.createWarningRule = createWarningRule;
function createSubsetAst(root, selectorPrefix, mixinTarget, isRoot = false) {
    // keyframes on class mixin?
    const prefixSelectorList = (0, selector_1.parseSelectorWithCache)(selectorPrefix);
    const prefixType = prefixSelectorList[0].nodes[0];
    const containsPrefix = containsMatchInFirstChunk.bind(null, prefixType);
    const mixinRoot = mixinTarget ? mixinTarget : postcss.root();
    root.nodes.forEach((node) => {
        if (node.type === `rule`) {
            const selectorAst = (0, selector_1.parseSelectorWithCache)(node.selector, { clone: true });
            const ast = isRoot
                ? (0, selector_1.scopeNestedSelector)(prefixSelectorList, selectorAst, true).ast
                : selectorAst;
            const matchesSelectors = isRoot ? ast : ast.filter((node) => containsPrefix(node));
            if (matchesSelectors.length) {
                const selector = (0, selector_1.stringifySelector)(matchesSelectors.map((selectorNode) => {
                    if (!isRoot) {
                        selectorNode = fixChunkOrdering(selectorNode, prefixType);
                    }
                    replaceTargetWithNesting(selectorNode, prefixType);
                    return selectorNode;
                }));
                mixinRoot.append(node.clone({ selector }));
            }
        }
        else if (node.type === `atrule`) {
            if (node.name === 'media' || node.name === 'supports' || node.name === 'layer') {
                const atRuleSubset = createSubsetAst(node, selectorPrefix, postcss.atRule({
                    params: node.params,
                    name: node.name,
                }), isRoot);
                if (atRuleSubset.nodes) {
                    mixinRoot.append(atRuleSubset);
                }
            }
            else if (isRoot) {
                mixinRoot.append(node.clone());
            }
        }
        else {
            // TODO: add warn?
        }
    });
    return mixinRoot;
}
exports.createSubsetAst = createSubsetAst;
function replaceTargetWithNesting(selectorNode, prefixType) {
    (0, selector_1.walkSelector)(selectorNode, (node) => {
        if ((0, selector_1.matchTypeAndValue)(node, prefixType)) {
            (0, selector_1.convertToSelector)(node).nodes = [
                {
                    type: `nesting`,
                    value: `&`,
                    start: node.start,
                    end: node.end,
                },
            ];
        }
    });
}
function fixChunkOrdering(selectorNode, prefixType) {
    const compound = (0, css_selector_parser_1.groupCompoundSelectors)(selectorNode, {
        deep: true,
        splitPseudoElements: false,
    });
    (0, selector_1.walkSelector)(compound, (node) => {
        if (node.type === `compound_selector`) {
            const simpleNodes = node.nodes;
            for (let i = 1; i < simpleNodes.length; i++) {
                const childNode = simpleNodes[i];
                if ((0, selector_1.matchTypeAndValue)(childNode, prefixType)) {
                    const chunk = simpleNodes.splice(i, simpleNodes.length - i);
                    simpleNodes.unshift(...chunk);
                    break;
                }
            }
        }
    });
    return compound;
}
function containsMatchInFirstChunk(prefixType, selectorNode) {
    let isMatch = false;
    (0, selector_1.walkSelector)(selectorNode, (node) => {
        if (node.type === `combinator`) {
            return selector_1.walkSelector.stopAll;
        }
        else if (node.type === 'pseudo_class') {
            // handle nested match :is(.mix)
            if (node.nodes) {
                for (const innerSelectorNode of node.nodes) {
                    if (containsMatchInFirstChunk(prefixType, innerSelectorNode)) {
                        isMatch = true;
                    }
                }
            }
            return selector_1.walkSelector.skipNested;
        }
        else if ((0, selector_1.matchTypeAndValue)(node, prefixType)) {
            isMatch = true;
            return selector_1.walkSelector.stopAll;
        }
        return;
    });
    return isMatch;
}
/** @deprecated internal for transformer  */
function findRule(root, selector, test = (statement) => statement.prop === `-st-extends`) {
    let found = null;
    root.walkRules(selector, (rule) => {
        const declarationIndex = rule.nodes ? rule.nodes.findIndex(test) : -1;
        const isSimplePerSelector = (0, selector_1.isSimpleSelector)(rule.selector);
        // This will assume that a selector that contains .a, .b:hover is simple! (for backward compatibility)
        const isSimple = isSimplePerSelector.reduce((acc, { isSimple }) => {
            return !isSimple ? false : acc;
        }, true);
        if (isSimple && !!~declarationIndex) {
            found = rule.nodes[declarationIndex];
        }
    });
    return found;
}
exports.findRule = findRule;
function getRuleScopeSelector(rule) {
    return (0, deprecation_1.ignoreDeprecationWarn)(() => rule.stScopeSelector);
}
exports.getRuleScopeSelector = getRuleScopeSelector;
//# sourceMappingURL=rule.js.map